<template>
    <div id="app" class="d-flex flex-column min-vh-100">
        <HeaderComponent />
        <main>
            <router-view></router-view>
        </main>
        <FooterComponent />
    </div>
</template>

<script>
import HeaderComponent from './components/Header.vue';
import FooterComponent from './components/Footer.vue';

export default {
    name: 'App',
    components: {
        HeaderComponent,
        FooterComponent,
    },
};
</script>

<style>
/* Adicione aqui os estilos globais do seu app, se necessário */
</style>